//  ViewMultipleTests.js
//
//  Updated 2/2.
//
//  Abstract: Create new tests functional component.

import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import { authMiddleware } from '../../../services/auth';

import { makeStyles } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { DataGrid } from '@material-ui/data-grid';

//	Define CSS styles.
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    customError: {
        color: 'red',
        fontSize: '0.8rem',
        marginTop: 10
    },
    progess: {
        position: 'absolute'
    },
    grid: {
        // height: '1000px',
        // width: 'auto',
        // maxWidth: '750px',
        // marginTop: '100px'
        // marginLeft: '0px'
    },
    datagrid: {

    },

}));

//  
export default function ViewMultipleTests(props) {

    //	CSS classes
    const classes = useStyles();

    //  Set state
    const [tests, setTests] = useState({});

    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'firstName', headerName: 'First name', width: 130 },
        { field: 'lastName', headerName: 'Last name', width: 130 },
        {
            field: 'age',
            headerName: 'Age',
            type: 'number',
            width: 90,
        },
        {
            field: 'fullName',
            headerName: 'Full name',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 160,
            valueGetter: (params) =>
                `${params.getValue('firstName') || ''} ${params.getValue('lastName') || ''}`,
        },
    ];


    useEffect(() => {
        // console.log(props.myFirstRow)
        // console.log(rows)

    
    });



    //  Update based on Firebase Firestore get
    // var rows;



    // const myTests = jsonToStrMap(test);
    // console.log(myTests);
    // Test rows based on response
    // var rows = [];






    //   This is an example of using these functions:
      
    //   > let myMap = new Map().set('yes', true).set('no', false);
    //   > strMapToJson(myMap)
    //   '{"yes":true,"no":false}'
    // //   > jsonToStrMap('{"yes":true,"no":false}');
    //   Map {'yes' => true, 'no' => false}


//     const testObj = JSON.parse(tests);
//     const 

//     const personsJson = `{"1":{"firstName":"Jan","lastName":"Kowalski"},"2":{"firstName":"Justyna","lastName":"Kowalczyk"}}`;
// const personsObject = JSON.parse(personsJson);
// const personsMap = new Map(Object.entries(personsObject));
// for (const key of personsMap.keys()) {
//     console.log(typeof key)
// }

    // rows
    // r
    // const { data } = this.props.highlights_data;

    //               Object.keys(data).map((e, i) => {
    //                 <SomeComponent key={i} {...e} />
    //               });
    //             }
    //         </div>
    //     )
    // }


//     app.get('/tests', auth, getAllTests);
// // Get all tests for the responsible user.
// exports.getAllTests = (request, response) => {
//     db
//         .collection('tests')
//         .where('email', '==', request.user.email)
//         .orderBy('createdAt', 'desc')
//         .get()
//         .then((data) => {
//             let tests = [];
//             data.forEach((doc) => {
//                 tests.push({
//                     testId: doc.id,
//                     patientId: doc.data().patientId,
//                     patchIdsArray: doc.data().patchIdsArray,
//                     createdAt: doc.data().createdAt
//                 });
//             });
//             return response.json(tests);
//         })
//         .catch((err) => {
//             console.error(err);
//             return response.status(500).json({ error: err.code });
//         });
// };
    

    
    const rows = [
        { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
        { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
        { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
        { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
        { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
        { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
        { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
        { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
        { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
        { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
        { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
        { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
        { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
        { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
        { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
        { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
        { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
        { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
        { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
        { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
        { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
        { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
        { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
        { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
        { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
        { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
        { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
    ];

    // const { rows } = props



    //	Set state.
    return (
        <>
            <Container>
                <CssBaseline />
                <div className={classes.grid}>
                    <DataGrid autoPageSize autoHeight rows={rows} columns={columns} checkboxSelection className={classes.datagrid} />
                </div>
            </Container>
        </>
    );
}
